<template>
  <div class="noselect">
    <b-container fluid class="header">
      <b-row>
        <b-col cols="12">
          <img class="p-3 logo mx-auto d-block" src="../../assets/img/easytick_color.png">
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col md="6" offset-md="3" xl="4" offset-xl="4">
          <b-list-group>
            <b-list-group-item :to="{ name: 'PublicIdChangeOwner' }" class="flex-column align-items-start mt-5">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-3">Alterar titularidade de ingresso digital</h5>
              </div>

              <p class="mb-3">
                Nesta opção você poderá alterar uma única vez a titularidade do seu ingresso.
              </p>

              <small>Caso de uso: Comprou o ingresso e deseja transferir para outra pessoa.</small>
            </b-list-group-item>

            <b-list-group-item :to="{ name: 'PublicIdCheckVeracity' }" class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-3">Conferir veracidade de ingresso digital</h5>
              </div>

              <p class="mb-3">
                Nesta opção você poderá conferir se um ingresso digital é verdadeiro.
              </p>

              <small>Caso de uso: Comprou um ingresso digital de segunda mão e deseja conferir se está registrado em seu nome.</small>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'PublicIdDashboard',
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
